export const mergeIds = (
  existingIds: string[],
  newIds: string[],
  isRefresh = false,
): string[] => {
  if (isRefresh) {
    return newIds;
  }
  return Array.from(new Set([...existingIds, ...newIds]));
};

export type PaginationState = { ids: string[]; mayLoadMore: boolean };

export const initialPaginationState: PaginationState = {
  ids: [],
  mayLoadMore: true,
};
